import React, { useState, useEffect, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import {
  getFollowUpsRequest,
  getFollowUpsForCalendarRequest,
  updateFollowUpRequest,
} from "./FollowUpsApiActions";
import { getAllDeptsRequest } from "../Departments/DepartmentsApiActions";
import { getCaseByIdRequest } from "../Cases/CasesApiAction";
import { addAppointmentRequest } from "../Appointments/AppointmentApiActions";

import { ROLES } from "../../utilities/constants";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  IconButton,
  Menu,
  MenuItem as MenuOption,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Grid,
  InputAdornment,
} from "@material-ui/core";
import { getUserInfo } from "../../utilities/storage";
import { useHistory } from "react-router-dom";
import { useStyles } from "./styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ViewListRoundedIcon from "@material-ui/icons/ViewListRounded";
import DateRangeRoundedIcon from "@material-ui/icons/DateRangeRounded";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import clsx from "clsx";
import FollowUpCalendar from "./components/FollowUpCalendar/FollowUpCalendar";
import FollowUpDaySidebar from "./components/FollowUpDaySidebar/FollowUpDaySidebar";
import {
  FOLLOWUP_STATUS_ORDER,
  followUpDay,
  mobileOf,
  patientNameOf,
  sortByStatus,
  statusMeta,
} from "./followUpHelpers";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import { getAppointmentDetailsRequest } from "../Appointments/AppointmentApiActions";

const VIEW_MODE_KEY = "followUpViewMode";

const FollowUpDashboard = ({
  followUps,
  totalCount,
  getAllFollowUps,
  getCalendarFollowUps,
  updateFollowUpStatus,
  getSingleCase,
  addAppointment,
  departmentData,
  getAllDepts,
  getAppointmentDetails,
}) => {
  const role = getUserInfo().Roles[0].name;
  const history = useHistory();
  const classes = useStyles();
  const formRef = React.useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFollowUp, setSelectedFollowUp] = useState(null);
  const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
  const [openAppointmentDialog, setOpenAppointmentDialog] = useState(false);
  const [newFollowUpDate, setNewFollowUpDate] = useState(null);
  const [caseData, setCaseData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedStartTime, setSelectedStartTime] = useState(new Date());
  const [selectedEndTime, setSelectedEndTime] = useState(
    new Date(new Date().getTime() + 60 * 60000)
  );
  const [selectedAppointmentType, setSelectedAppointmentType] =
    useState("offline");
  const [selectedAppointmentLink, setSelectedAppointmentLink] = useState("");
  const [enrichedFollowUps, setEnrichedFollowUps] = useState([]);
  const [paginationParams, setPaginationParams] = useState({
    page: 0,
    rowsPerPage: 10,
    searchData: {
      patientName: "",
      mobileNumber: "",
      status: "",
    },
  });

  // --- List / Calendar view ---
  // The chosen view sticks per browser so a doctor who works off the calendar
  // does not land on the table on every visit.
  const [viewMode, setViewMode] = useState(
    () => localStorage.getItem(VIEW_MODE_KEY) || "list"
  );
  const [calendarFollowUps, setCalendarFollowUps] = useState([]);
  const [calMonth, setCalMonth] = useState(() => moment().startOf("month"));
  const [selectedDay, setSelectedDay] = useState(() => moment());
  // followUpId -> appointmentDate, filled in only for the selected day.
  const [appointmentDates, setAppointmentDates] = useState({});

  // --- Filters (shared by both views) ---
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchInput.trim()), 400);
    return () => clearTimeout(timer);
  }, [searchInput]);

  // A digits-only query is a mobile number, anything else is a name; the
  // endpoint takes the two separately.
  useEffect(() => {
    const isMobile = /^\d+$/.test(debouncedSearch);
    setPaginationParams((prev) => ({
      ...prev,
      page: 0,
      searchData: {
        patientName: isMobile ? "" : debouncedSearch,
        mobileNumber: isMobile ? debouncedSearch : "",
        status: statusFilter,
      },
    }));
  }, [debouncedSearch, statusFilter]);

  const loadCalendar = useCallback(
    () =>
      getCalendarFollowUps(paginationParams.searchData)
        .then((rows) => {
          setAppointmentDates({});
          setCalendarFollowUps(rows || []);
        })
        .catch(() => setCalendarFollowUps([])),
    [getCalendarFollowUps, paginationParams.searchData]
  );

  useEffect(() => {
    if (viewMode === "list") getAllFollowUps(paginationParams);
  }, [viewMode, paginationParams, getAllFollowUps]);

  useEffect(() => {
    if (viewMode === "calendar") loadCalendar();
  }, [viewMode, loadCalendar]);

  // Reloads whichever view is on screen after an action changes a follow-up.
  const refresh = useCallback(
    () =>
      viewMode === "calendar" ? loadCalendar() : getAllFollowUps(paginationParams),
    [viewMode, loadCalendar, getAllFollowUps, paginationParams]
  );

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
    localStorage.setItem(VIEW_MODE_KEY, mode);
  };

  useEffect(() => {
    getAllDepts().then((res) => {});
  }, [getAllDepts]);

  const handleChangePage = (event, newPage) => {
    setPaginationParams((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    }));
  };

  const handleMenuClick = (event, followUp) => {
    setAnchorEl(event.currentTarget);
    setSelectedFollowUp(followUp);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCaseClick = (caseId) => {
    history.push(`/cases/${caseId}`);
  };

  const openRescheduleFor = (followUp) => {
    setSelectedFollowUp(followUp);
    setNewFollowUpDate(new Date());
    setOpenRescheduleDialog(true);
  };

  const handleReschedule = () => {
    openRescheduleFor(selectedFollowUp);
    handleMenuClose();
  };

  const formatTime = (time) => {
    if (!time) return "";
    const hours = time.getHours().toString().padStart(2, "0");
    const minutes = time.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const handleTimeChange = (event, setTime, selectedDate) => {
    const [hours, minutes] = event.target.value.split(":").map(Number);
    const newTime = new Date(selectedDate);
    newTime.setHours(hours, minutes, 0, 0);
    setTime(newTime);
  };

  const mergeDateAndTime = (dateMs, timeMs) => {
    if (!dateMs || !timeMs) return null;
    const date = new Date(dateMs);
    const time = new Date(timeMs);
    date.setHours(time.getHours(), time.getMinutes(), 0, 0);
    return date.getTime();
  };

  // The table shows one page at a time, so enriching every row with its
  // appointment date is a handful of calls. The calendar holds far more rows,
  // and enriches only the selected day (below) instead.
  useEffect(() => {
    const enrichFollowUps = async () => {
      if (viewMode !== "list" || !followUps?.length) return;

      const updatedFollowUps = await Promise.all(
        followUps.map(async (fu) => {
          if (fu.appointmentId) {
            try {
              const appointment = await getAppointmentDetails(fu.appointmentId);
              return {
                ...fu,
                appointmentDate: appointment?.appointmentDate || null,
              };
            } catch (err) {
              console.error("Failed to fetch appointment", err);
              return { ...fu, appointmentDate: null };
            }
          }
          return { ...fu, appointmentDate: null };
        })
      );

      setEnrichedFollowUps(updatedFollowUps);
    };

    enrichFollowUps();
  }, [followUps, viewMode]);

  const dayFollowUps = useMemo(
    () =>
      sortByStatus(
        calendarFollowUps.filter((fu) => {
          const day = followUpDay(fu.followUpDate);
          return day && day.isSame(selectedDay, "day");
        })
      ),
    [calendarFollowUps, selectedDay]
  );

  // Appointment dates for the selected day only (a few calls at most). Already
  // resolved ids are skipped, so re-selecting a day costs nothing.
  useEffect(() => {
    const missing = dayFollowUps.filter(
      (fu) => fu.appointmentId && appointmentDates[fu.id] === undefined
    );
    if (!missing.length) return undefined;

    let active = true;
    Promise.all(
      missing.map((fu) =>
        getAppointmentDetails(fu.appointmentId)
          .then((appointment) => [fu.id, appointment?.appointmentDate || null])
          .catch(() => [fu.id, null])
      )
    ).then((entries) => {
      if (!active) return;
      setAppointmentDates((prev) => {
        const next = { ...prev };
        entries.forEach(([id, date]) => {
          next[id] = date;
        });
        return next;
      });
    });

    return () => {
      active = false;
    };
    // appointmentDates is read as a cache, not a trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dayFollowUps, getAppointmentDetails]);

  const dayFollowUpsWithAppointment = dayFollowUps.map((fu) => ({
    ...fu,
    appointmentDate: appointmentDates[fu.id] || null,
  }));

  const handleSelectDay = (day) => {
    setSelectedDay(day.clone());
    if (day.month() !== calMonth.month()) {
      setCalMonth(day.clone().startOf("month"));
    }
  };

  const handleToday = () => {
    const today = moment();
    setSelectedDay(today);
    setCalMonth(today.clone().startOf("month"));
  };

  const handleViewAppointment = async () => {
    if (selectedFollowUp?.appointmentId) {
      try {
        const appointmentDetails = await getAppointmentDetails(
          selectedFollowUp.appointmentId
        );
        if (appointmentDetails) {
          const caseResponse = await getSingleCase(appointmentDetails.CaseId);
          setCaseData(caseResponse || null);
          setSelectedTitle(appointmentDetails.title || "");
          const dept = departmentData?.rows?.find(
            (d) => d.id === appointmentDetails.TeamId
          );
          setSelectedDept(dept || null);

          setSelectedStartTime(new Date(appointmentDetails.startTime));
          setSelectedEndTime(new Date(appointmentDetails.endTime));
          setSelectedDate(new Date(appointmentDetails.appointmentDate));
          setSelectedAppointmentType(
            appointmentDetails.appointmentType || "offline"
          );
          setSelectedAppointmentLink(appointmentDetails.appointmentLink || "");

          setOpenAppointmentDialog(true);
        }
      } catch (error) {
        console.error("Error fetching appointment details:", error);
        alert("Failed to fetch appointment details");
      }
    } else {
      alert("Appointment details not available.");
    }

    handleMenuClose();
  };

  const handleScheduleAppointment = async () => {
    if (selectedFollowUp && selectedFollowUp.caseId) {
      try {
        const caseResponse = await getSingleCase(selectedFollowUp.caseId);

        if (caseResponse) {
          setCaseData(caseResponse);

          const dept = departmentData?.rows?.find(
            (d) => d.id === caseResponse.TeamId
          );

          setSelectedDept(dept || null);

          setSelectedDate(new Date().getTime());
          setSelectedTitle("");
          setSelectedStartTime(new Date());
          setSelectedEndTime(new Date(new Date().getTime() + 60 * 60000));
          setSelectedAppointmentType("offline");
          setSelectedAppointmentLink("");

          setOpenAppointmentDialog(true);
        } else {
          alert("No case data found");
        }
      } catch (error) {
        console.error("Error fetching case:", error);
        alert("Failed to fetch case details");
      }
    }
    handleMenuClose();
  };

  const handleNoActionNeeded = async () => {
    if (selectedFollowUp) {
      try {
        await updateFollowUpStatus(selectedFollowUp.id, {
          status: "Closed",
          action: "No Action Needed",
        });
        await refresh();
      } catch (error) {
        console.error("Error updating follow-up:", error);
        alert("Failed to update follow-up");
      }
    }
    handleMenuClose();
  };

  const handleRescheduleSubmit = async () => {
    if (selectedFollowUp && newFollowUpDate) {
      try {
        await updateFollowUpStatus(selectedFollowUp.id, {
          status: "Rescheduled",
          action: "Reschedule Follow-Up",
          followUpDate: moment(newFollowUpDate).format("YYYY-MM-DD"),
        });
        await refresh();
        setOpenRescheduleDialog(false);
        setNewFollowUpDate(null);
      } catch (error) {
        console.error("Error rescheduling follow-up:", error);
        alert("Failed to reschedule follow-up");
      }
    }
  };

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault();

    if (!selectedDate || !selectedStartTime || !selectedEndTime) return;

    const appointmentPayload = {
      appointmentDate: selectedDate
        ? new Date(selectedDate).getTime()
        : new Date().getTime(),
      startTime: mergeDateAndTime(selectedDate, selectedStartTime),
      endTime: mergeDateAndTime(selectedDate, selectedEndTime),
      title: selectedTitle,
      patientId: caseData?.PatientId,
      userId: caseData?.Users?.[0]?.userId,
      caseId: caseData?.id,
      teamId: caseData?.TeamId,
      appointmentLink: selectedAppointmentLink || "",
      appointmentType: selectedAppointmentType || "offline",
      followUpId: selectedFollowUp.id || 0,
    };

    try {
      await addAppointment(appointmentPayload);

      await updateFollowUpStatus(selectedFollowUp.id, {
        status: "Appointment Scheduled",
        action: "Schedule Appointment",
      });

      await refresh();

      setOpenAppointmentDialog(false);
      setCaseData(null);
      setSelectedDate(null);
      setSelectedTitle("");
      setSelectedStartTime(new Date());
      setSelectedEndTime(new Date(new Date().getTime() + 60 * 60000));
      setSelectedAppointmentType("offline");
      setSelectedAppointmentLink("");
    } catch (error) {
      console.error("Error creating appointment:", error);
      alert("Failed to create appointment");
    }
  };
  const isViewMode = Boolean(selectedFollowUp?.appointmentId);

  return (
    <Box className={classes.pageRoot}>
      <Box className={classes.headerCard}>
        <Typography className={classes.pageTitle}>Follow-Up List</Typography>

        <Box className={classes.headerRight}>
          <TextField
            select
            size="small"
            variant="outlined"
            label="Status"
            className={classes.filterField}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            {FOLLOWUP_STATUS_ORDER.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            size="small"
            variant="outlined"
            label="Patient name or mobile"
            className={classes.filterField}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon fontSize="small" htmlColor="#9aa4b2" />
                </InputAdornment>
              ),
            }}
          />

          <Box className={classes.viewToggle}>
            <Button
              disableElevation
              startIcon={<ViewListRoundedIcon />}
              className={clsx(
                classes.viewToggleBtn,
                viewMode === "list" && classes.viewToggleBtnActive
              )}
              onClick={() => handleViewModeChange("list")}
            >
              List
            </Button>
            <Button
              disableElevation
              startIcon={<DateRangeRoundedIcon />}
              className={clsx(
                classes.viewToggleBtn,
                viewMode === "calendar" && classes.viewToggleBtnActive
              )}
              onClick={() => handleViewModeChange("calendar")}
            >
              Calendar
            </Button>
          </Box>
        </Box>
      </Box>

      {viewMode === "calendar" ? (
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={9}>
            <FollowUpCalendar
              followUps={calendarFollowUps}
              calMonth={calMonth}
              selectedDate={selectedDay}
              onSelectDay={handleSelectDay}
              onPrevMonth={() =>
                setCalMonth((prev) => prev.clone().subtract(1, "month"))
              }
              onNextMonth={() =>
                setCalMonth((prev) => prev.clone().add(1, "month"))
              }
              onToday={handleToday}
            />
          </Grid>

          <Grid item xs={12} md={4} lg={3}>
            <FollowUpDaySidebar
              selectedDate={selectedDay}
              followUps={dayFollowUpsWithAppointment}
              onCaseClick={handleCaseClick}
              onReschedule={openRescheduleFor}
              onMenuClick={handleMenuClick}
            />
          </Grid>
        </Grid>
      ) : (
      <Paper className={classes.tablePaper}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell}>Case ID</TableCell>
                <TableCell className={classes.tableCell}>
                  Patient Name
                </TableCell>
                <TableCell className={classes.tableCell}>
                  Mobile Number
                </TableCell>

                <TableCell className={classes.tableCell}>
                  Follow-Up Date
                </TableCell>

                <TableCell className={classes.tableCell}>
                  Appointment Date
                </TableCell>

                <TableCell className={classes.tableCell}>Status</TableCell>

                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {enrichedFollowUps?.map((fu) => {
                const patientName = patientNameOf(fu);
                const mobileNumber = mobileOf(fu);
                const meta = statusMeta(fu.status);

                return (
                  <TableRow key={fu.id}>
                    <TableCell
                      className={classes.clickableCell}
                      onClick={() => handleCaseClick(fu.caseId)}
                    >
                      {fu.caseId}
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      {patientName}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {mobileNumber}
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      {fu.followUpDate
                        ? new Date(fu.followUpDate).toLocaleDateString("en-GB")
                        : "N/A"}
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      {fu.status === "Appointment Scheduled" &&
                      fu.appointmentDate
                        ? new Date(fu.appointmentDate).toLocaleDateString(
                            "en-GB"
                          )
                        : "—"}
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      <Chip
                        label={fu.status}
                        size="small"
                        className={classes.statusChip}
                        style={{
                          color: meta.color,
                          backgroundColor: meta.bg,
                        }}
                      />
                    </TableCell>

                    <TableCell align="right">
                      <Box className={classes.actionCell}>
                        {fu.action ? (
                          <Chip
                            label={fu.action}
                            size="small"
                            color="primary"
                            variant="outlined"
                          />
                        ) : (
                          <Typography variant="caption" color="textSecondary">
                            No action
                          </Typography>
                        )}

                        {fu.status !== "Closed" && (
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuClick(e, fu)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}

              {!enrichedFollowUps?.length && (
                <TableRow>
                  <TableCell colSpan={7} className={classes.emptyRow}>
                    No follow-ups match the current filters
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={totalCount}
          page={paginationParams.page}
          onPageChange={handleChangePage}
          rowsPerPage={paginationParams.rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      )}

      {/* Action Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuOption onClick={handleReschedule}>
            Reschedule Follow-Up
          </MenuOption>

          {role === ROLES.ROLE_RECEPTIONIST &&
            selectedFollowUp?.status !== "Appointment Scheduled" && (
              <MenuOption onClick={handleScheduleAppointment}>
                Schedule Appointment
              </MenuOption>
            )}

          {(role === ROLES.ROLE_DOCTOR || role === ROLES.ROLE_RECEPTIONIST) &&
            selectedFollowUp?.status === "Appointment Scheduled" && (
              <MenuOption onClick={handleViewAppointment}>
                View Appointment
              </MenuOption>
            )}

          <MenuOption onClick={handleNoActionNeeded}>
            No Action Needed (Close)
          </MenuOption>
        </Menu>

        {/* Reschedule Dialog */}
        <Dialog
          open={openRescheduleDialog}
          onClose={() => setOpenRescheduleDialog(false)}
        >
          <DialogTitle>Reschedule Follow-Up</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                fullWidth
                label="New Follow-Up Date"
                inputVariant="outlined"
                format="dd/MM/yyyy"
                minDate={new Date()}
                value={newFollowUpDate}
                onChange={setNewFollowUpDate}
                className={classes.formField}
              />
            </MuiPickersUtilsProvider>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenRescheduleDialog(false)}>
              Cancel
            </Button>
            <Button
              onClick={handleRescheduleSubmit}
              color="primary"
              variant="contained"
              disabled={!newFollowUpDate}
            >
              Reschedule
            </Button>
          </DialogActions>
        </Dialog>

        {/* Schedule Appointment Dialog */}
        <Dialog
          open={openAppointmentDialog}
          onClose={() => setOpenAppointmentDialog(false)}
        >
          <ValidatorForm ref={formRef} onSubmit={handleAppointmentSubmit}>
            <Box className={classes.modalTitle}>
              <DialogTitle>
                {selectedFollowUp?.appointmentId
                  ? "View Appointment"
                  : "Schedule Appointment"}
              </DialogTitle>{" "}
            </Box>
            <DialogContent className={classes.appointmentModal}>
              {caseData && (
                <Grid container spacing={2}>
                  {!isViewMode && (
                    <Grid item xs={12}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                          fullWidth
                          label="Appointment Date *"
                          inputVariant="outlined"
                          format="dd/MM/yyyy"
                          minDate={new Date()}
                          value={selectedDate}
                          onChange={setSelectedDate}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <TextValidator
                      fullWidth
                      label="Title *"
                      size="small"
                      variant="outlined"
                      value={selectedTitle}
                      onChange={(e) => setSelectedTitle(e.target.value)}
                      validators={["required"]}
                      errorMessages={["Title is required"]}
                      disabled={isViewMode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Department"
                      size="small"
                      variant="outlined"
                      value={selectedDept?.name || ""}
                      disabled={isViewMode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Patient"
                      size="small"
                      variant="outlined"
                      value={`${caseData.Patient?.firstname || ""} ${
                        caseData.Patient?.lastname || ""
                      }`}
                      disabled={isViewMode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Case"
                      size="small"
                      variant="outlined"
                      value={caseData.desc || ""}
                      disabled={isViewMode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextValidator
                      fullWidth
                      type="time"
                      label="Start Time *"
                      placeholder="Start Time"
                      size="small"
                      value={formatTime(selectedStartTime)}
                      variant="outlined"
                      onChange={(e) =>
                        handleTimeChange(e, setSelectedStartTime, selectedDate)
                      }
                      validators={["required"]}
                      errorMessages={["Start Time is required"]}
                      disabled={isViewMode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextValidator
                      fullWidth
                      type="time"
                      label="End Time *"
                      size="small"
                      value={formatTime(selectedEndTime)}
                      variant="outlined"
                      onChange={(e) =>
                        handleTimeChange(e, setSelectedEndTime, selectedDate)
                      }
                      validators={["required"]}
                      errorMessages={["End Time is required"]}
                      disabled={isViewMode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <SelectValidator
                      fullWidth
                      label="Appointment Type *"
                      name="appointmentType"
                      size="small"
                      variant="outlined"
                      value={selectedAppointmentType}
                      onChange={(e) =>
                        setSelectedAppointmentType(e.target.value)
                      }
                      validators={["required"]}
                      errorMessages={["Appointment Type is required"]}
                      disabled={isViewMode}
                    >
                      <MenuItem value="online">Online</MenuItem>
                      <MenuItem value="offline">Offline</MenuItem>
                    </SelectValidator>
                  </Grid>

                  <Grid item xs={12}>
                    <TextValidator
                      fullWidth
                      label="Appointment Link"
                      size="small"
                      variant="outlined"
                      value={selectedAppointmentLink}
                      onChange={(e) =>
                        setSelectedAppointmentLink(e.target.value)
                      }
                      disabled={isViewMode}
                    />
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAppointmentDialog(false)}>
                Cancel
              </Button>
              <Button type="submit" color="primary" disableElevation={true}>
                Save
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  followUps: state.followUps.followUps,
  totalCount: state.followUps.totalCount,
  departmentData: state.departments.depts,
  doctors: state.doctors?.doctors?.rows,
});

const mapDispatchToProps = (dispatch) => ({
  getAllFollowUps: (params) => dispatch(getFollowUpsRequest(params)),
  getCalendarFollowUps: (searchData) =>
    dispatch(getFollowUpsForCalendarRequest(searchData)).then(
      (res) => Promise.resolve(res),
      (error) => Promise.reject(error)
    ),
  updateFollowUpStatus: (followUpId, data) =>
    dispatch(updateFollowUpRequest(followUpId, data)),
  getSingleCase: (id) => {
    return dispatch(getCaseByIdRequest(id)).then(
      (res) => Promise.resolve(res),
      (error) => Promise.reject(error)
    );
  },
  addAppointment: (data) => {
    return dispatch(addAppointmentRequest(data)).then(
      (res) => Promise.resolve(res),
      (error) => Promise.reject(error)
    );
  },
  getAllDepts: () => {
    return dispatch(getAllDeptsRequest()).then(
      (res) => {
        return Promise.resolve(res);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
  getAppointmentDetails: (id) => {
    return dispatch(getAppointmentDetailsRequest(id)).then(
      (res) => {
        return Promise.resolve(res);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpDashboard);
